import { createCollectionLoadedComponent } from "./createCollectionLoadedComponent"
import { UserEntriesCollectionContext } from "src/contexts/CollectionContext"

export const UserEntriesLoadedComponent = createCollectionLoadedComponent(
  UserEntriesCollectionContext,
)
